import { defineEvent, defineModule, f } from "../../contract";

/** A plain observation: "the windmill in North is squeaking", "42 looks thin". Always safe to file. */
const note = defineEvent<{ text: string; attention?: boolean }>({
  type: "core.note",
  label: "Note",
  description: "Something someone noticed that doesn't fit a more specific record.",
  icon: "note",
  tone: "note",
  subjects: [
    { role: "animal", kind: "animal", label: "Animals", many: true },
    { role: "group", kind: "group", label: "Group" },
    { role: "place", kind: "place", label: "Place" },
    { role: "asset", kind: "asset", label: "Equipment" },
    { role: "contact", kind: "contact", label: "Person" },
  ],
  fields: {
    text: f.longText("Note", { required: true, agent: "Keep the speaker's wording and language. Do not translate." }),
    attention: f.bool("Needs attention", { level: "more", agent: "true only when the speaker says it needs follow-up or is a problem" }),
  },
  summary: (e) => e.data.text,
  agent: {
    when: "Use only when no specific record type fits. Prefer a specific type (treatment, move, weight, repair) when the words support it.",
    examples: ["the north windmill is squeaking again", "42 is looking thin"],
  },
});

export default defineModule({
  id: "core",
  label: "Core",
  description: "Notes, observations and the records every module shares.",
  events: [note],
});
